// import React from "react";
// import rocket from "../Assets/pngtree-cartoon-rocket-clipart-for-kids---free-png-image_16194745.png"
// function Pre(props) {
// return (
//   <div className="loader-div">
//     <div className="loader-wrapper">
//       <span className="loader"></span>
//       <span className="loader-text"><img src={rocket} alt="rocket"/></span>
//     </div>
//   </div>
// );

// }


// // {props.load?"loader-div":"no-load"}
// // {props.load?"loader":"no-load"}

// export default Pre;
import React from "react";
import rocket from "../Assets/pngtree-cartoon-rocket-clipart-for-kids---free-png-image_16194745.24b7cd54248a6791e32c-Photoroom.png";

function Pre(props) {
  return (
    <div className={props.load?"loader-div":"no-load"}>
      {/* Wind-streak particles */}
      <ul className="loader-wind-particles">
        {Array.from({ length: 40 }).map((_, i) => (
          <li key={i}></li>
        ))}
      </ul>

      <div className="loader-wrapper">
        <span className="loader"></span>
        <span className="loader-text">
          <img src={rocket} alt="rocket" />
        </span>
      </div>
    </div>
  );
}

export default Pre;
